import { render, staticRenderFns } from "./CompanyForm.vue?vue&type=template&id=0fce6631&scoped=true&lang=html&"
import script from "./CompanyForm.vue?vue&type=script&lang=js&"
export * from "./CompanyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce6631",
  null
  
)

export default component.exports